import { DefaultEffects, ITheme, mergeStyles } from '@fluentui/react';

export const actionBarStyles = (theme: ITheme): ReturnType<typeof mergeStyles> =>
    mergeStyles({
        backgroundColor: theme.palette.neutralLighterAlt,
        transition: 'opacity 0.25s ease-in-out',
        width: 'auto',
        boxShadow: DefaultEffects.elevation16,
        padding: '8px 16px'
    });

export const iconButtonStylesSelected = mergeStyles({
    borderRadius: 4,
    padding: 8,
    cursor: 'pointer',
    border: '1px solid var(--stroke-gray-100, #C9CAC8)',
    background: 'var(--stroke-gray-50, #E4E4E3)',
    boxShadow: '4px 4px 4px 0px rgba(0, 0, 0, 0.25) inset',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    selectors: {
        ':hover': { backgroundColor: 'rgba(0, 0, 0, 0.1)' },
        ':active': { backgroundColor: 'rgba(0, 0, 0, 0.2)' }
    }
});

export const iconButtonStylesDefault = (isSavingBtn = false): ReturnType<typeof mergeStyles> =>
    mergeStyles({
        borderRadius: 4,
        padding: isSavingBtn ? '0px 8px 0px 4px' : 8,
        cursor: 'pointer',
        border: '1px solid transparent',
        background: 'transparent',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        selectors: isSavingBtn
            ? {}
            : {
                  ':hover': { backgroundColor: 'rgba(0, 0, 0, 0.1)' },
                  ':active': { backgroundColor: 'rgba(0, 0, 0, 0.2)' }
              }
    });
